import React, { FC, useState, useEffect } from "react";
import { DisableButton } from "utils/DisableButton";
import { generateRandomId } from "utils/GenerateRandomId";
import { Tooltip } from "react-tooltip";
import * as S from './styles';

interface IInputComponent {
  onBlur?: any;
  alt?: string;
  ol?: boolean;
  type?: string;
  onFocus?: any;
  onChange?: any;
  value?: string;
  width?: string;
  setIsValid?: any;
  pattern?: string;
  isValid?: boolean;
  readOnly?: boolean;
  maxLength?: number;
  minLength?: number;
  className?: string;
  autoFocus?: boolean;
  isPayment?: boolean;
  placeholder?: string;
  isPricedAccordingly?: boolean;
  tooltipText?: string;
}

const Input: FC<IInputComponent> = (props) => {
  const {
    ol,
    alt,
    type,
    value,
    onBlur,
    pattern,
    isValid,
    onFocus,
    onChange,
    className,
    isPayment,
    setIsValid,
    placeholder,
    minLength = 0,
    maxLength = 50,
    width = '100%',
    readOnly = false,
    autoFocus = false,
    isPricedAccordingly,
    tooltipText = '',
  } = props;
  const [text, setText] = useState<string>('');

  const reactTooltipId = generateRandomId("ReactTooltipReport");

  useEffect(() => {
    value && setText(value);
  }, [value]);

  const handleChange = (e: any) => {
    const valid = e.target.validity.valid;
    let text = e.target.value;

    if (valid) {
      setIsValid(true);
      setText(text);
      onChange(text);
    } else {
      setIsValid(false);
    }

  };

  const handleBlur = () => {
    if (typeof onBlur == "function") {
      onBlur();
    }
  };

  const handleFocus = () => {
    if (typeof onFocus == "function") {
      onFocus();
    }
  };

  const patternFactory = () => {
    if (pattern)
      return pattern;
    else if (type === 'number')
      return `[0-9,]{0,${maxLength}}`;
    else
      return '';
  };

  return (
    <S.Input
      ol={ol}
      width={width}
      isValid={isValid}
      isPayment={isPayment}
      isPricedAccordingly={isPricedAccordingly}
    >
      <input
        id={reactTooltipId}
        readOnly={readOnly}
        disabled={readOnly}
        autoFocus={autoFocus}
        data-testid="input-generic-quotes"
        className={`${className} ${DisableButton(readOnly)}`}
        type={'text'}
        placeholder={placeholder || ''}
        onChange={(e: any) => handleChange(e)}
        onBlur={handleBlur}
        onFocus={handleFocus}
        value={text}
        pattern={patternFactory()}
        minLength={minLength}
        maxLength={maxLength}
        alt={alt}
      />
      {tooltipText && <Tooltip place="top" variant="light" anchorSelect={'#' + reactTooltipId} content={tooltipText}></Tooltip>}
    </S.Input>
  );
};

export default Input;
